var _title, _desc, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMoreDots = function SvgMoreDots(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "6px",
    viewBox: "0 0 28 6",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Element/Icon/Plus")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element/Button/Float-Button",
    transform: "translate(-11.000000, -22.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element/Button/Add-Button"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Element/Icon/Options",
    transform: "translate(11.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.53684211,16.8 C2.07183414,16.8 0.884210526,15.6123764 0.884210526,14.1473684 C0.884210526,12.6823605 2.07183414,11.4947368 3.53684211,11.4947368 C5.00185007,11.4947368 6.18947368,12.6823605 6.18947368,14.1473684 C6.18947368,15.6123764 5.00185007,16.8 3.53684211,16.8 Z M14.1473684,16.8 C12.6823605,16.8 11.4947368,15.6123764 11.4947368,14.1473684 C11.4947368,12.6823605 12.6823605,11.4947368 14.1473684,11.4947368 C15.6123764,11.4947368 16.8,12.6823605 16.8,14.1473684 C16.8,15.6123764 15.6123764,16.8 14.1473684,16.8 Z M24.7578947,16.8 C23.2928868,16.8 22.1052632,15.6123764 22.1052632,14.1473684 C22.1052632,12.6823605 23.2928868,11.4947368 24.7578947,11.4947368 C26.2229027,11.4947368 27.4105263,12.6823605 27.4105263,14.1473684 C27.4105263,15.6123764 26.2229027,16.8 24.7578947,16.8 Z",
    id: "\\uD83C\\uDFA8-Icon-color"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoreDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/more-dots.1ead6f91.svg";
export { ForwardRef as ReactComponent };